export enum AutomationsRoutes {
  Macros = "/automations/macros",
  EditMacro = "/automations/macros/edit",
  AddMacro = "/automations/macros/add",
  Rules = "/automations/rules",
  EditRule = "/automations/rules/edit",
  AddRule = "/automations/rules/add",
  /**
   * @deprecated Use `Rules` instead.
   */
  Workflows = "/automations/workflows",
  /**
   * @deprecated Use `EditRule` instead.
   */
  EditWorkflow = "/automations/workflows/edit",
  /**
   * @deprecated Use `AddRule` instead.
   */
  AddWorkflow = "/automations/workflows/add",
}

export enum AutomationType {
  Rule = "rule",
  Macro = "macro",
}

export const WORKFLOW_CHANGES_NOT_SAVED_MODAL_DESC =
  "You have unsaved changes in the rule. They'll be lost if you close the rule editor without saving them.";
